// extracted by mini-css-extract-plugin
export default {"cls1":"AOYL36cV7_6KkBxOU2Ig","cls2":"ZM7BWDnUq9X0iOwSDoYZ AOYL36cV7_6KkBxOU2Ig","isDesktopUp":"pLAoLUPqDmOZRTchmNtd","bookingAppRedesign":"_7cSnGXOJgqXUonlOqrn"};